export enum DATA_QA {
  ROOT = 'dnc-field-mapper',
  ROW = 'dnc-field-mapper__row',
  VALIDATION_ICON = 'dnc-field-mapper__validation-icon',
}
